import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import LegalFooter from './components/app_bar/LegalFooter';
export default function Layout({ children }) {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) document.getElementById(hash.slice(1))?.scrollIntoView({ behavior: 'smooth' });
    else window.scrollTo(0, 0);
  }, [pathname, hash]);
  return <><main className={`site-main ${pathname.startsWith('/creative-mode') ? `creative-shell ${pathname.endsWith('/play') ? '' : 'creative-form-shell'}` : ''}`}>{children}</main><footer className="site-footer"><span>MADE FOR A GOOD NIGHT TOGETHER.</span><p>Any drink. Any pace. Always optional.</p><LegalFooter /></footer></>;
}
